<template>
  <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Enter Barcode Manually
    </Teleport>

    <cf-validated-form
      ref="manualBardcodeForm"
      name="manualBarcodeForm"
      @valid-submit="handleSumbit"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <cf-text-input
          id="frmBarcode"
          ref="manualBarcodeForm"
          v-model="manuallyEnteredBarcode"
          type="text"
          label="Barcode"
          name="barcode"
          :validations="{
            required: true,
          }"
        />

        <button
          type="submit"
          class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        >
          Submit
        </button>
      </div>
    </cf-validated-form>
  </div>
</template>


<script>
  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'ManualBarcodeEntry',

    components: {
      CfValidatedForm,
      CfTextInput
    },

    data() {
      return { manuallyEnteredBarcode: '' };
    },

    mounted() {
      this.manuallyEnteredBarcode = '';
    },

    methods: {
      async handleSumbit() {
        const claimPayload = { type: 'posReceiptToken', value: this.manuallyEnteredBarcode.trim() };

        const result = await this.$store.dispatch('offers/claimPreviousOrder', claimPayload);

        if (result) {
          this.$closeModal('manualBarcodeEntry');

          this.manuallyEnteredBarcode = '';
        }
      }
    }
  };
</script>
